import type { Role } from '@commissions/auth/roles';

/**
 * Badge colour for a role chip. Purely cosmetic — not an authorization
 * decision, which is why a default is safe here in a way it would not be in
 * a gate.
 *
 * Keyed on the SHAPE of the role name rather than a list of literals: the
 * previous switch coloured only Admin/Approver/Analyst/Viewer, so every role
 * in the nine-role policy already fell through to 'neutral' and the four
 * coloured cases were dead by the time they were deleted.
 */
export function roleTone(role: Role): 'danger' | 'warning' | 'info' | 'neutral' {
  if (role === 'SysAdmin' || role === 'SuperUser') return 'danger';
  if (role.startsWith('Level')) return 'info';
  return 'neutral';
}
